// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"b817a11c","453":"481d806d","640":"2c72231b","918":"76e9464b","985":"db002f84","995":"1214bee6"}[chunkId] + ".chunk.js";
};